import { formatDollars } from '@kwenta/sdk/utils'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import CalculatorIcon from 'assets/svg/futures/calculator-icon.svg'
import DepositWithdrawArrowsIcon from 'assets/svg/futures/deposit-withdraw-arrows.svg'
import { FlexDivRow } from 'components/layout/flex'
import { Body } from 'components/Text'
import { setOpenModal, setOpenModalWithParams } from 'state/app/reducer'
import { selectPerpsProvider } from 'state/futures/common/selectors'
import { setProfitCalculatorVisible } from 'state/futures/reducer'
import {
	selectCrossMarginAccount,
	selectCrossMarginMarginInfo,
} from 'state/futures/snxPerpsV3/selectors'
import { ManageModalType, PerpsProvider } from 'state/futures/types'
import { useAppDispatch, useAppSelector } from 'state/hooks'

const TradePanelAvailableMargin: React.FC = () => {
	const { t } = useTranslation()
	const { availableMargin } = useAppSelector(selectCrossMarginMarginInfo)
	const perpsProvider = useAppSelector(selectPerpsProvider)
	const crossMarginAccount = useAppSelector(selectCrossMarginAccount)
	const dispatch = useAppDispatch()

	const handleShowProfitCalculator = useCallback(() => {
		dispatch(setProfitCalculatorVisible(true))
	}, [dispatch])

	return (
		<Container>
			<AvailableMarginContainer>
				<Body color="secondary">{t('futures.market.trade.trade-balance.available')}:</Body>
				<StyledRow
					onClick={() =>
						dispatch(
							crossMarginAccount
								? setOpenModalWithParams({
										type:
											perpsProvider === PerpsProvider.SNX_V3
												? 'futures_deposit_withdraw_cross_margin'
												: 'futures_deposit_withdraw_smart_margin',
										params: { tab: ManageModalType.Deposit },
								  })
								: setOpenModal('futures_cross_margin_onboard')
						)
					}
				>
					<Body color="primary">{formatDollars(availableMargin)}</Body>
					{!!crossMarginAccount && <DepositWithdrawArrowsIcon />}
				</StyledRow>
			</AvailableMarginContainer>
			<CalculatorContainer onClick={handleShowProfitCalculator}>
				<Body color="secondary">{t('futures.market.trade.trade-balance.calculator')}</Body>
				<CalculatorIcon />
			</CalculatorContainer>
		</Container>
	)
}

const Container = styled(FlexDivRow)`
	margin-bottom: 8px;
`

const CalculatorContainer = styled.div`
	display: flex;
	gap: 7px;
	cursor: pointer;
`

const AvailableMarginContainer = styled.div`
	display: flex;
	gap: 7px;
`

const StyledRow = styled(FlexDivRow)`
	cursor: pointer;
	gap: 7px;
`

export default TradePanelAvailableMargin
